"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _swiper = require("swiper");
var _react2 = require("swiper/react");
const _excluded = ["children", "keys", "spaceBetween", "navigation", "freeMode"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const SwiperLayoutGrid = props => {
  const {
      children,
      keys = [],
      spaceBetween = 40,
      navigation = true,
      freeMode = true
    } = props,
    swiperProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react2.Swiper, _extends({
    freeMode: freeMode,
    modules: [_swiper.FreeMode, _swiper.Navigation],
    slidesPerView: 'auto',
    spaceBetween: spaceBetween,
    navigation: navigation,
    grabCursor: true
  }, swiperProps, {
    className: "SwiperLayoutGrid ".concat(swiperProps.className || '')
  }), children.map((child, i) => /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
    key: keys[i]
  }, child)));
};
var _default = exports.default = SwiperLayoutGrid;